// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__l89qe","checkbox":"Checkbox_checkbox__71xI9","label":"Checkbox_label__O-SB1","expand":"Checkbox_expand__hjSyR","disabled":"Checkbox_disabled__h5VEk"};